import { IMedia } from "src/model/unityObject";

const hasMediaBeenGeneratedByAi = (media: IMedia) => {
  let metadata = null;
  if (media.metadata) {
    if (typeof media.metadata === "object") {
      metadata = media.metadata;
    } else if (typeof media.metadata === "string") {
      try {
        metadata = JSON.parse(media.metadata);
      } catch (e) {
        console.log("JSON.parse : Unable to parse string, is it really a JSON string ?");
      }
    }
  }
  return metadata && typeof metadata === "object" && metadata.initialPrompt;
};

export default hasMediaBeenGeneratedByAi;
